import { render, staticRenderFns } from "./TestQuestions.vue?vue&type=template&id=1ac1356c&scoped=true"
import script from "./TestQuestions.vue?vue&type=script&lang=js"
export * from "./TestQuestions.vue?vue&type=script&lang=js"
import style0 from "./TestQuestions.vue?vue&type=style&index=0&id=1ac1356c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ac1356c",
  null
  
)

export default component.exports